import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
   {
    path: '/',
    name: 'Index',
    component: () => import('../views/index.vue')
  },
  {
    path: '/solutions/aviation',
    name: 'Aviation',
    component: () => import('../views/solutions/aviation.vue')
  },
  {
    path: '/solutions/training',
    name: 'training',
    component: () => import('../views/solutions/training.vue')
  },
  {
    path: '/solutions/industry',
    name: 'industry',
    component: () => import('../views/solutions/industry.vue')
  },
  {
    path: '/solutions/lowAltitude',
    name: 'lowAltitude',
    component: () => import('../views/solutions/lowAltitude.vue')
  },
  {
    path: '/products/XR1',
    name: 'XR1',
    component: () => import('../views/products/XR1.vue')
  },
  {
    path: '/products/XR2',
    name: 'XR2',
    component: () => import('../views/products/XR2.vue')
  },
  {
    path: '/products/VR1',
    name: 'VR1',
    component: () => import('../views/products/VR1.vue')
  },
  {
    path: '/products/VR2',
    name: 'VR2',
    component: () => import('../views/products/VR2.vue')
  },
  {
    path: '/products/AR1',
    name: 'AR1',
    component: () => import('../views/products/AR1.vue')
  },
  {
    path: '/news',
    name: 'News',
    component: () => import('../views/news.vue')
  },
  {
    path: '/about',
    name: 'About',
    component: () => import('../views/about.vue')
  },
  {
    path: '/contactUs',
    name: 'ContactUs',
    component: () => import('../views/contactUs.vue')
  },
  {
    path: '/newsDetail/:id',
    name: 'NewsDetail',
    component: () => import('../views/newsDetail.vue')
  },
  {
    path: '/support',
    name: 'support',
    component: () => import('../views/support.vue')
  }
]

const router = new VueRouter({
  mode: 'history',
  routes,
  scrollBehavior (to, from, savedPosition) {
    // 如果路由对象中包含hash，且hash对应页面中的一个元素
    if (to.hash) {
      const element = document.getElementById(to.hash.slice(1)); // slice(1) 移除hash中的'#'
      if (element) {
        // 如果找到元素，则返回其位置
        return { selector: to.hash };
      }
    }
    // 否则，返回默认的滚动位置
    return { x: 0, y: 0 };
  }
})

// const router = new VueRouter({
//   mode: 'history',
//   routes,
//   scrollBehavior(to, from, savedPosition) {
//     return { x: 0, y: 0 }
//   }
// })

export default router
